import React from "react";
import { useNavigate } from "react-router-dom";
import { FiInfo, FiCheckSquare } from "react-icons/fi";

const ComplianceRecords = () => {
  const navigate = useNavigate();

  const categories = [
    {
      label: "Opening",
      count: "12",
      textStyle: "text-blue-600",
      bgStyle: "bg-blue-50/50",
    },
    {
      label: "Food Safety",
      count: "14",
      textStyle: "text-emerald-600",
      bgStyle: "bg-emerald-50/50",
    },
    {
      label: "Cleaning",
      count: "9",
      textStyle: "text-teal-600",
      bgStyle: "bg-teal-50/50",
    },
    {
      label: "Equipment",
      count: "3",
      textStyle: "text-purple-600",
      bgStyle: "bg-purple-50/50",
    },
  ];

  return (
    <div className="w-full max-w-[360px] bg-white border border-slate-100 rounded-2xl p-5 shadow-sm font-sans">
      {/* Widget Header Row */}
      <div className="flex items-center gap-1.5 mb-4">
        <h3 className="text-sm font-bold text-slate-900">
          Compliance Records Generated Today
        </h3>

        <FiInfo className="text-slate-300 text-xs cursor-help shrink-0" />
      </div>

      {/* Main Metric & Action Button Row */}
      <div className="flex items-center justify-between gap-4 mb-5">
        <div className="flex items-center gap-3">
          {/* Clipboard Icon */}
          <div className="w-11 h-11 bg-blue-50 border border-blue-100 rounded-xl flex items-center justify-center shrink-0">
            <FiCheckSquare className="text-blue-600 text-lg" />
          </div>

          {/* Counter Text */}
          <div>
            <p className="text-2xl font-bold text-slate-800 leading-none">38</p>

            <p className="text-[10px] text-slate-400 mt-1">Total records</p>
          </div>
        </div>

        {/* View Compliance Centre */}
        <button
          type="button"
          onClick={() => navigate("/compliance-center")}
          className="border border-slate-200 hover:border-indigo-600 text-indigo-600 hover:bg-slate-50 font-semibold text-xs py-2 px-3 rounded-lg shadow-sm transition-all whitespace-nowrap"
        >
          View Compliance Centre
        </button>
      </div>

      {/* Bottom Category Distribution Cards Grid */}
      <div className="grid grid-cols-4 gap-2">
        {categories.map((item, idx) => (
          <div
            key={idx}
            className={`rounded-xl p-2.5 flex flex-col items-center justify-center text-center ${item.bgStyle}`}
          >
            <span
              className={`text-[9px] font-bold tracking-wide ${item.textStyle}`}
            >
              {item.label}
            </span>

            <span className="text-base font-bold text-slate-800 mt-1">
              {item.count}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ComplianceRecords;
